var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSendToken(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1557_942)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.84815 2.49865L1.64682 8.69998C0.100346 10.2465 0.100346 12.7538 1.64682 14.3003L7.84815 20.5016C9.39462 22.0481 11.902 22.0481 13.4484 20.5016L19.6498 14.3003C21.1962 12.7538 21.1962 10.2465 19.6498 8.69998L13.4484 2.49865C11.902 0.952176 9.39462 0.952177 7.84815 2.49865Z",
    fill: "#76808D",
    stroke: "#76808D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1401 9.50012L10.6501 5.01012L6.17014 9.50012",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6499 5.01011L10.6499 17.9901",
    stroke: "white",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1557_942"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.32,
    height: 21.32,
    fill: "white",
    transform: "translate(0 0.840088)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendToken);
export default __webpack_public_path__ + "static/media/sendToken.7d215417cf865fe1194034af2b70210a.svg";
export { ForwardRef as ReactComponent };